<template>
  <v-container>
    <PageHeadingText :title="$t('seo.mySubscriptions')" />
    <HeroHeadTitle :title="$t('profile.manageTitle')"></HeroHeadTitle>
    <template v-if="loading">
      <loader></loader>
    </template>
    <template v-else>
      <template v-if="
          $subscription.userIsSubscribed ||
          $subscription.inActiveSubscriptions.length ||
          $subscription.canceledSubscriptions.length ||
          $subscription.pendingSubscriptions.length
        ">
        <template v-if="!isMonsooqMent && !onlyOneSubscriptionFlow">
          <div class="page-container">
            <h2 class="header-title">{{ $t('profile.manageTitle') }}</h2>
            <div class="subscriptions-container">
              <template v-if="$subscription.userIsSubscribed">
                <h3 class="subscription-label"
                  >{{ $t('profile.active') }}:</h3
                >
                <div class="active-subscriptions subscriptions">
                  <div class="card-container" v-for="subscription in $subscription.userActiveSubscription"
                    :key="subscription.id">
                    <component :is="subscriptionCard" :subscription="subscription"></component>
                  </div>
                </div>
              </template>
              <template v-if="$subscription.inActiveSubscriptions.length">
                <h3 class="subscription-label"
                  >{{ $t('profile.inActive') }}:</h3
                >
                <div class="previous-subscriptions subscriptions">
                  <div class="card-container" v-for="subscription in $subscription.inActiveSubscriptions"
                    :key="subscription.id">
                    <component :is="subscriptionCard" :subscription="subscription"></component>
                  </div>
                </div>
              </template>
              <template v-if="$subscription.pendingSubscriptions.length">
                <span class="subscription-label">{{ $t('profile.pending') }}:</span>
                <div class="previous-subscriptions subscriptions">
                  <div class="card-container" v-for="subscription in $subscription.pendingSubscriptions"
                    :key="subscription.id">
                    <component :is="subscriptionCard" :subscription="subscription"></component>
                  </div>
                </div>
              </template>
              <template v-if="
                  $subscription.canceledSubscriptions.length &&
                  !disableSubscriptionHistory
                ">
                <span class="subscription-label">{{ $t('profile.history') }}:</span>
                <div class="previous-subscriptions subscriptions">
                  <div class="card-container" v-for="subscription in $subscription.canceledSubscriptions"
                    :key="subscription.id">
                    <component :is="subscriptionCard" :subscription="subscription"></component>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template v-else-if="onlyOneSubscriptionFlow">
          <div class="hello">
            <component :is="subscriptionCard" :subscription="userOneSubscription"></component>
          </div>

        </template>
        <template v-else>
          <div class="monsooq-page-container">
            <h2 class="monsooq-header-title">
              {{ $t('profile.manageTitle') }}
            </h2>
            <div class="monsooq-subscriptions-container">
              <template v-if="$subscription.userIsSubscribed">
                <span class="monsooq-subscription-label">{{ $t('profile.active') }}
                  <span class="monsooq-subscription-count">({{ $subscription.userActiveSubscription.length }})</span>
                </span>
                <div class="monsooq-active-subscriptions monsooq-subscriptions">
                  <div class="monsooq-card-container" v-for="subscription in $subscription.userActiveSubscription"
                    :key="subscription.id">
                    <component :is="subscriptionCard" :subscription="subscription"></component>
                  </div>
                </div>
              </template>
              <template v-if="$subscription.inActiveSubscriptions.length">
                <span class="monsooq-subscription-label">{{ $t('profile.inActive') }}:</span>
                <div class="monsooq-previous-subscriptions monsooq-subscriptions">
                  <div class="monsooq-card-container" v-for="subscription in $subscription.inActiveSubscriptions"
                    :key="subscription.id">
                    <component :is="subscriptionCard" :subscription="subscription"></component>
                  </div>
                </div>
              </template>
              <template v-if="$subscription.pendingSubscriptions.length">
                <span class="monsooq-subscription-label">{{ $t('profile.pending') }}:</span>
                <div class="monsooq-previous-subscriptions monsooq-subscriptions">
                  <div class="monsooq-card-container" v-for="subscription in $subscription.pendingSubscriptions"
                    :key="subscription.id">
                    <component :is="subscriptionCard" :subscription="subscription"></component>
                  </div>
                </div>
              </template>
              <template v-if="
                  $subscription.canceledSubscriptions.length &&
                  !disableSubscriptionHistory
                ">
                <span class="monsooq-subscription-label">{{ $t('profile.history') }}:</span>
                <div class="monsooq-previous-subscriptions monsooq-subscriptions">
                  <div class="monsooq-card-container" v-for="subscription in $subscription.canceledSubscriptions"
                    :key="subscription.id">
                    <component :is="subscriptionCard" :subscription="subscription"></component>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </template>
    </template>
    <template v-if="!loading">
      <Root v-for="structure in structures" :key="structure?.id" v-bind="{ structure }">
      </Root>
    </template>

  </v-container>
</template>

<script lang="ts">
import { bindTabName } from '@/api/utils';
import { defineAsyncComponent } from 'vue';
// Todo -> be updated after we convert to setup
definePageMeta({
  middleware: ['protect-route'],
});


export default defineNuxtComponent({
  async setup() {
    const { $t, $api } = useNuxtApp();
    const route = useRoute();
    const { data: structures, error } = await useAsyncData(
      'structure',
      async () => {
        const queries = route.query ? route.query : {};
        const structureName = 'profile_manage_subscriptions';
        const structures = await $api.endPoints.getStructure(
          structureName,
          queries,
        );
        return structures;
      },
    );
    if (error?.value) {
      // throw createError({ statusCode: 404, message: 'Not Found' });
    }
    useHead({
      title: bindTabName({
        title: $t('seo.mySubscriptions') as string,
      }),
    });
    return {
      structures,
    };
  },
  name: 'Manage',
  components: {
    PageHeadingText: defineAsyncComponent(
      () => import('@/components/shared/PageHeadingText.vue'),
    ),
    HeroHeadTitle: defineAsyncComponent(
      () => import('@/components/shared/HeroHeadTitle.vue'),
    ),
    MonsooqUserSubscriptionCard: defineAsyncComponent(
      () => import('@/components/cards/MonsooqUserSubscriptionCard.vue'),
    ),
    UserSubscriptionCard: defineAsyncComponent(
      () => import('@/components/cards/UserSubscriptionCard.vue'),
    ),

  },

  data() {
    return {
      loading: true as boolean,
    };
  },
  watch: {
    '$subscription.userIsSubscribed': {
      handler(userIsSubscribed) {
        if (userIsSubscribed && this.$subscription.subsIsReady >= 0) {
          this.loading = false;
        } else {
          setTimeout(() => {
            this.loading = false;
          }, 5000);
        }
      },
      immediate: true,
    },
    '$route.query': {
      handler(query) {
        if (query.cancellationFlow) {
          const text =
            query.status == '200'
              ? (this.$t('subscription.cancel.successMsg') as string)
              : (this.$t('subscription.cancel.failMsg') as string);
          this.$snackbar.openSnackbar(text);
          this.$router.replace({}).catch(() => {});
        }
      },
      immediate: true,
    },
  },
  computed: {
    isMonsooqMent() {
      return this.$api.tenant?.default?.monsooqMent;
    },
    disableSubscriptionHistory() {
      return (
        this.$globals.enabledFeatures &&
        this.$globals.enabledFeatures.disableSubscriptionHistory == 'true'
      );
    },
    subscriptionCard() {
      switch (true) {
        case !!this.onlyOneSubscriptionFlow:
          return 'UserOneSubscriptionCard';
        case !!this.isMonsooqMent:
          return 'MonsooqUserSubscriptionCard';
        default:
          return 'UserSubscriptionCard';
      }
    },

    onlyOneSubscriptionFlow() {
      return this.$api.tenant.default.oneSubscriptionFlow;
    },
    userOneSubscription() {
      switch (true) {
        case this.$subscription?.userIsSubscribed && this.$subscription?.userActiveSubscription?.length > 0:
          return this.$subscription.userActiveSubscription[0];
        case this.$subscription?.inActiveSubscriptions?.length > 0:
          return this.$subscription.inActiveSubscriptions[0];
        case this.$subscription?.canceledSubscriptions?.length > 0:
          return this.$subscription.canceledSubscriptions[0];
        default:
          return;
      }
    }
  },
});
</script>

<style lang="scss" scoped>
.back__container {
  margin-top: 0;
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    margin-top: 40px;
  }
}

.page-container {
  .header-title {
    font-size: 1rem;
  }

  .subscriptions {
    display: flex;
    flex-wrap: wrap;
  }

  .subscription-label {
    display: block;
    margin-top: 15px;
    font-size: 0.75rem;
  }

  .card-container {
    margin: 20px 30px 30px 0;

    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      margin: 20px 0;
      width: 100%;
    }

    .v-locale--is-rtl & {
      margin-right: 0;
      margin-left: 30px;
    }
  }

  &.no-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;

    .caution {
      font-size: 1rem;
      margin-bottom: 5px;

      &.dimmed {
        color: var(--omega-37-67);
        background: transparent !important;
      }
    }

    p.caution {
      margin-top: 10px;
    }

    .discover-btn {
      margin-top: 30px;
      padding: 8px 35px;
      background-color: var(--primary);
      font-size: 1rem;
      color: var(--white);
      border-radius: 2px;

      .v-application-is-rtl & {
        transform: scaleX(-1);
      }
    }
  }

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    .header-title {
      margin-bottom: 30px;
      font-size: 1.875rem;
    }

    .subscription-label {
      margin-top: 0;
      font-size: 1rem;
    }

    &.no-content {
      .caution {
        font-size: 1.25rem;
      }

      .discover-btn {
        margin-top: 20px;
        font-size: 1rem;
      }
    }

    width: 50%;
    margin: 0 auto;
  }
}

.monsooq-page-container {
  margin: 0 16px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin: 0 16px;
  }

  @media #{map-get($display-breakpoints, 'md')} {
    margin: 0 73px;
  }

  @media #{map-get($display-breakpoints, 'lg-and-up')} {
    margin: 0 278px;
  }

  .monsooq-header-title {
    font-size: 24px;

    @media #{map-get($display-breakpoints, 'md-and-up')} {
      font-size: 28px;
    }
  }

  .monsooq-subscription-label {
    display: block;
    margin: 1rem 0;
    font-size: 20px;
    font-weight: 700;

    @media #{map-get($display-breakpoints, 'md-and-up')} {
      font-size: 24px;
      display: flex;
      gap: 8px;
    }
  }

  .monsooq-subscription-count {
    font-size: 14px;
    font-weight: 400;
    color: rgba(var(--omega-rgb), 0.5);
  }

  .monsooq-subscriptions {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .monsooq-card-container {
    width: 100%;
  }
}

.loading {
  width: 100%;
  height: 50%;
  position: relative;
  left: 50%;
  right: 50%;
  top: 50%;
  bottom: 50%;
}
</style>
